import { locales } from '@@/shared-components/locales/index'
interface BranchesQuery {
  branches: Branch[]
  phones: { [key: number]: Contact[] }
  emails: { [key: number]: Contact[] }
}

export const branchesQuery = ({
  dataLang,
  channel,
}: {
  dataLang: Ref<ValueOf<typeof locales>>
  channel: Ref<string | null>
}) =>
  queryOptions({
    queryKey: ['branches', channel, dataLang],
    queryFn: async ({ signal }) =>
      await useCustomFetch<{ data: Branch[] }>({
        url: '/public/branches',
        thumbs: {
          image: { style: 's' },
        },
        options: {
          headers: { 'X-Lang': dataLang.value },
        },
        clientOnly: true,
        signal,
      }),
    select: (branchesData): BranchesQuery => {
      const phones: { [key: number]: Contact[] } = {}
      const emails: { [key: number]: Contact[] } = {}
      branchesData?.data.forEach((b) => {
        const branchPhones: Contact[] = []
        const branchEmails: Contact[] = []
        b.contacts.forEach((c) => {
          if (c.key === 'phone') {
            branchPhones.push(c)
          }
          if (c.key === 'email') {
            branchEmails.push(c)
          }
        })
        phones[b.id] = branchPhones
        emails[b.id] = branchEmails
      })
      return { branches: branchesData?.data ?? [], phones, emails }
    },
  })

export const branchQuery = ({
  id,
  query,
  thumbs,
  hasPreview,
  origin,
  dataLang,
}: {
  id: Ref<string>
  query?: object
  thumbs?: {
    [key: string]: object
  }
  hasPreview?: { expires: string; signature: string }
  origin?: string
  dataLang: Ref<ValueOf<typeof locales>>
}) =>
  queryOptions({
    queryKey: ['branches', id, dataLang],
    queryFn: async () =>
      await useCustomFetch<{ data: Branch }>({
        url: `/public/branches/${hasPreview ? 'p/' : ''}${id.value}`,
        query: { ...query, ...(hasPreview ?? {}) },
        options: {
          headers: { 'X-Lang': dataLang.value },
        },
        origin,
        thumbs,
        clientOnly: true,
      }),
  })

export const shippingBranchesQuery = queryOptions({
  queryKey: ['shipping-branches'],
  queryFn: async () => {
    const response = await useCustomFetch<{ data: Branch[] }>({
      url: '/public/shippings/branches',
    })
    return response.data.value?.data ?? []
  },
  retry: 0,
})
